// Shared visual tokens for the Analyze module, aligned with the
// "Promoter Ninja UI" Claude Design mockup (Analyze.dc.html).
import muiTheme from 'client/muiTheme';

export const INK = '#1A2230';
export const MUTED = '#8A94A6';
export const SECONDARY = '#5B6675';
export const BORDER = '#ECEFF3';
export const BORDER_STRONG = '#E2E7EE';
export const SURFACE_ALT = '#F8FAFC';

// Brand accent — always the theme primary color (used for tabs, funnel "shown"
// stage, choice bars, etc.) so the Analyze UI tracks the app palette.
export const BLUE = muiTheme.palette.primary.main;
export const PURPLE = '#7A5AF8';

export const PROMOTER = '#1FB573';
export const PASSIVE = '#E8A93C';
export const DETRACTOR = '#EE5A52';

// Maps the survey-type group keys (see groupsByType) to mockup colors.
export const GROUP_COLORS = {
  promoters: PROMOTER,
  passives: PASSIVE,
  detractors: DETRACTOR,
  agree: PROMOTER,
  neutral: PASSIVE,
  disagree: DETRACTOR,
  satisfied: PROMOTER,
  dissatisfied: DETRACTOR,
};

// Color ramp for star-rating groups ("5-stars" … "1-stars").
const STAR_COLORS = {
  5: PROMOTER,
  4: '#5FC98C',
  3: PASSIVE,
  2: '#F08A4B',
  1: DETRACTOR,
};

// Resolves the bar/dot color for any survey-type group key.
export function groupColor(group) {
  if (GROUP_COLORS[group]) {
    return GROUP_COLORS[group];
  }
  const num = parseInt(group, 10);
  return STAR_COLORS[num] || '#C7CFDA';
}

// Color for an individual score on a 0–10 (NPS) or rating scale.
export function scoreColor(score, surveyType = 'nps') {
  if (surveyType === 'star_five') {
    if (score <= 2) return DETRACTOR;
    if (score <= 3) return PASSIVE;
    return PROMOTER;
  }
  if (score <= 6) return DETRACTOR;
  if (score <= 8) return PASSIVE;
  return PROMOTER;
}

// Tinted background + text for an NPS pill given its value.
export function npsPill(value) {
  if (value == null) return { color: SECONDARY, bg: SURFACE_ALT };
  if (value >= 30) return { color: '#1AAE6F', bg: '#E6F7EF' };
  if (value >= 0) return { color: '#B07A12', bg: '#FBF3E2' };
  return { color: '#D6453C', bg: '#FCEBEA' };
}

const SHADOW = '0 1px 2px rgba(16,24,40,.04), 0 4px 12px rgba(16,24,40,.04)';

// Reusable card surface matching the mockup.
export const cardSx = {
  backgroundColor: '#fff',
  border: `1px solid ${BORDER}`,
  borderRadius: '14px',
  boxShadow: SHADOW,
  p: '24px 26px',
};

export const sectionTitleSx = {
  m: 0,
  fontSize: 16,
  fontWeight: 700,
  color: INK,
};

export const captionSx = {
  fontSize: 13,
  color: MUTED,
};

// Uppercase column-header style used by the Analyze tables.
export const tableHeadCellSx = {
  fontSize: 11.5,
  fontWeight: 700,
  letterSpacing: '.5px',
  textTransform: 'uppercase',
  color: MUTED,
};
